import * as api from '@gitbook/api-client';
import { Badge } from '@gitbook/spine-react';

import { useTrial } from '../../../../state';

/**
 * A badge showing that a trial is available. Suspends rendering.
 */
function TrialBadge(props: { organization: api.Organization }) {
    const { organization } = props;
    const trial = useTrial({ organization });

    const canStartTrial = trial.status === api.BillingTrialStatus.None;
    const isOnTrial = trial.status === api.BillingTrialStatus.Active;

    // No trial available
    if (!canStartTrial && !isOnTrial) {
        return null;
    }

    // User is either on a trial, or has a trial available.
    return (
        <Badge
            size="xsmall"
            kind="info"
            label={canStartTrial ? '14-day free trial' : 'Included in trial'}
        />
    );
}
export default TrialBadge;
